import type { ThemeConfig } from 'antd';

const MGRV_GREEN = '#00B453';

export const antdTheme = {
  hashed: false,
  token: {
    // Use project's default font.
    fontFamily: 'inherit',

    // Reduce font size for displaying more informations to screen.
    fontSize: 12,

    // Reduce animation duration time by half.
    motionDurationFast: '0.05s',
    motionDurationMid: '0.1s',
    motionDurationSlow: '0.15s',

    // Change color.
    colorBgLayout: 'white',
    colorPrimary: MGRV_GREEN,
    colorLink: MGRV_GREEN,
    colorInfo: MGRV_GREEN,
    colorSuccess: MGRV_GREEN,
  },
  components: {
    Layout: {
      headerHeight: 56,
      headerPadding: '0 32px',
    },
    Menu: {
      itemHeight: 36,
      itemPaddingInline: 8,
    },
    Tabs: {
      horizontalMargin: '0',
      colorBorderSecondary: '#E2E2E2',
      cardPaddingSM: '8px 14px',
    },
    Table: {
      cellPaddingBlockSM: 4,
    },
    Input: {
      inputFontSizeSM: 12,
    },
    Button: {
      contentFontSizeSM: 12,
    },
  },
} as const satisfies ThemeConfig;
